import {
  getToggleAllText,
  MultiFilter,
  toggleAllMultiFilter,
  toggleMultiFilterOption,
} from "model/Filter/Filter";
import { ToggleFilterContainer, FilterHeader } from "../styles";
import { FunctionsContainer, ToggleContainer, ToggleOption } from "./styles";
import { SecondaryButton } from "styles/elements";

interface Props<T extends string> {
  filter: MultiFilter<T>;
  header?: string;
  onChange?: () => void;
}

export function MultiToggleFilter<T extends string>({
  filter,
  header,
  onChange,
}: Props<T>) {
  return (
    <ToggleFilterContainer>
      {!!header && <FilterHeader>{header}</FilterHeader>}
      <ToggleContainer>
        {filter.options.map((o) => (
          <ToggleOption
            key={o}
            selected={filter.selectedValues.includes(o)}
            onClick={() => {
              toggleMultiFilterOption(filter, o);
              if (!!onChange) {
                onChange();
              }
            }}
          >
            {o}
          </ToggleOption>
        ))}
      </ToggleContainer>
      {filter.options.length > 1 && (
        <FunctionsContainer>
          <SecondaryButton onClick={() => toggleAllMultiFilter(filter)}>
            {getToggleAllText(filter)}
          </SecondaryButton>
        </FunctionsContainer>
      )}
    </ToggleFilterContainer>
  );
}
